module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-1800.63a6b20a.svg";